import dayjs from "dayjs";

// TODO need to be removed. This is a debit used to bypass a sdkgen problem and a API
// misconception, using datetime instead date
export function middleDay(date: Date) {
	return dayjs(date).hour(12).toDate();
}
